import axios from 'axios';

export const ServiceProvidersApi = {
  loadTableData: filter =>
    axios.get(`/api/public/data/service_provider_by_service_type_and_location?${filter}`),
  searchServiceProvider: filter =>
    axios.get(`/api/public/data/service_provider_by_filter`, { params: filter })
};
